import type {Money} from "../../../../../lib/Money.ts";
import type {PanelBooking} from "../types.ts";

export function dropPrePeriodBookings(
    bookings: PanelBooking[],
    openingBalance: Money | null,
    periodStartDate: string,
): PanelBooking[] {
    if (openingBalance === null) return bookings;
    return bookings.filter((booking) => booking.date === null || booking.date >= periodStartDate);
}
